import { get } from '@/services/API';

export default {
  getDailyLivestock: (date) => get(`/api/livestock/daily?date=${date}`),
  getYearlyLivestock: (year) => get(`/api/livestock/yearly?year=${year}`),
  getYears: () => get('/api/livestock/years'),
};
